import { combineReducers } from 'redux';

import currentProperty from 'app/shared/reducers/properties/currentProperty';
import properties from 'app/shared/reducers/properties/properties';
import propertiesFilters from 'app/shared/reducers/properties/propertiesFilters';
import propertyConversion from 'app/shared/reducers/properties/propertyConversion';

const rootPropertiesReducer = combineReducers({
    currentProperty,
    properties,
    propertiesFilters,
    propertyConversion,
});

export default rootPropertiesReducer;
